/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：499
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.json = exports.block = exports.string = exports.color = exports.asserts = exports.array = exports.maths = exports.math = exports.base = exports.event = exports.dom = exports.style = exports.is = undefined
var r = require(/* 93 */"tslib")
var i = (0, r.__importStar)(require(/* 723 */"../../123/723"))
exports.style = i
var o = (0, r.__importStar)(require(/* 123 */"../../123/index"))
exports.dom = o
var a = (0, r.__importStar)(require(/* 1126 */"./1126"))
exports.event = a
var s = (0, r.__importStar)(require(/* 214 */"../../1022/214"))
exports.base = s
var c = (0, r.__importStar)(require(/* 293 */"../../123/293"))
exports.math = c
exports.maths = c
var u = (0, r.__importStar)(require(/* 975 */"./975"))
exports.array = u
var l = (0, r.__importStar)(require(/* 387 */"../../207/734/387"))
exports.asserts = l
var f = (0, r.__importStar)(require(/* 579 */"../../1022/579"))
exports.color = f
var d = (0, r.__importStar)(require(/* 852 */"./852"))
exports.string = d
var h = require(/* 478 */"../../123/478")
Object.defineProperty(exports, "is", {
  enumerable: true,
  get: function () {
    return h.is
  }
})
var p = (0, r.__importStar)(require(/* 648 */"../../1205/2609/648"))
exports.block = p
var _ = (0, r.__importStar)(require(/* 976 */"./976"))
exports.json = _
